export const SENTRY_HOST = 'o483267.ingest.sentry.io';
export const SENTRY_PROJECT = '6485152';
export const SENTRY_DSN = `https://f04bda89bdbb4b72a75d2733aeafb6ee@${SENTRY_HOST}/${SENTRY_PROJECT}`;
